type StandKey = 'one' | 'test' | 'local';

type StandConfig = {
  id: StandKey;
  title: string;
  headerClassName: string;
  footerClassName: string;
  logoSrc: string;
};

const STAND_CONFIG: Record<StandKey, StandConfig> = {
  one: {
    id: 'one',
    title: 'One.BigClock.ru - центр управления часами',
    headerClassName: 'header-bg--one',
    footerClassName: 'footer-bg--one',
    logoSrc: 'logo 2.svg'
  },
  test: {
    id: 'test',
    title: 'Test.BigClock.ru - центр управления часами',
    headerClassName: 'header-bg--test',
    footerClassName: 'footer-bg--test',
    logoSrc: 'logo_improved.svg'
  },
  local: {
    id: 'local',
    title: 'Local.BigClock.ru - центр управления часами',
    headerClassName: 'header-bg--local',
    footerClassName: 'footer-bg--local',
    logoSrc: 'logo 2.svg'
  }
};

export function detectStand(hostname: string = window.location.hostname): StandKey {
  const normalizedHostname = hostname.toLowerCase();

  if (normalizedHostname.includes('test.bigclock.ru')) {
    return 'test';
  }

  if (
    normalizedHostname === 'localhost'
    || normalizedHostname === '127.0.0.1'
    || normalizedHostname === '0.0.0.0'
  ) {
    return 'local';
  }

  return 'one';
}

export function getStandConfig(hostname: string = window.location.hostname): StandConfig {
  return STAND_CONFIG[detectStand(hostname)];
}

export function applyStandSettings(doc: Document = document): StandConfig {
  const standConfig = getStandConfig(doc.location.hostname);

  doc.title = standConfig.title;
  doc.body.dataset.stand = standConfig.id;

  return standConfig;
}
